/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 48, height = 48 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M40.5 8V19H37.5V13.15L28.3 22.3C29 23.2667 29.5417 24.325 29.925 25.475C30.3083 26.625 30.5 27.8 30.5 29C30.5 32.0667 29.4333 34.6667 27.3 36.8C25.1667 38.9333 22.5667 40 19.5 40C16.4333 40 13.8333 38.9333 11.7 36.8C9.56667 34.6667 8.5 32.0667 8.5 29C8.5 25.9333 9.56667 23.3333 11.7 21.2C13.8333 19.0667 16.4333 18 19.5 18C20.7 18 21.8667 18.1917 23 18.575C24.1333 18.9583 25.1833 19.5 26.15 20.2L35.35 11H29.5V8H40.5ZM19.5 21C17.3 21 15.4167 21.7833 13.85 23.35C12.2833 24.9167 11.5 26.8 11.5 29C11.5 31.2 12.2833 33.0833 13.85 34.65C15.4167 36.2167 17.3 37 19.5 37C21.7 37 23.5833 36.2167 25.15 34.65C26.7167 33.0833 27.5 31.2 27.5 29C27.5 26.8 26.7167 24.9167 25.15 23.35C23.5833 21.7833 21.7 21 19.5 21Z" fill="#262626" />
  </svg>
);

export default SvgComponent;
